__turbopack_context__.v({
  "Collapsible": "GTRWtW_Collapsible",
  "Content": "GTRWtW_Content",
  "Icon": "GTRWtW_Icon",
  "Panel": "GTRWtW_Panel",
  "Trigger": "GTRWtW_Trigger",
  "addButton": "GTRWtW_addButton",
  "badge": "GTRWtW_badge",
  "col": "GTRWtW_col",
  "disabled": "GTRWtW_disabled",
  "error": "GTRWtW_error",
  "errorMsg": "GTRWtW_errorMsg",
  "header": "GTRWtW_header",
  "hidePlaceholder": "GTRWtW_hidePlaceholder",
  "hint": "GTRWtW_hint",
  "input": "GTRWtW_input",
  "inputContent": "GTRWtW_inputContent",
  "inputLabel": "GTRWtW_inputLabel",
  "primary": "GTRWtW_primary",
  "required": "GTRWtW_required",
  "root": "GTRWtW_root",
  "row": "GTRWtW_row",
  "secondary": "GTRWtW_secondary",
  "selectedList": "GTRWtW_selectedList",
  "textInput": "GTRWtW_textInput",
  "title": "GTRWtW_title",
  "warning": "GTRWtW_warning",
});
